import { PRINTER_LABEL } from '../actionTypes';

const initialState = {
  content: [],
  labelList: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PRINTER_LABEL.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case PRINTER_LABEL.SUCCESS_LIST:
      return {
        ...state,
        labelList: action.payload,
      };
    default:
      return state;
  }
};
